import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./style.css";
import BurdCrumbs from "../../components/burdCrumbs";
import TableLayout from "../../components/table";
import Modal from "../../components/modal";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import { Loader } from "rsuite";
import { Input } from "../../components/form-elements";
import { addition } from "../../assets/svgIcons";
import { userData } from "../../data/fake_login_data";
import { perms } from "../../data/side_nav_data";
import { exportToCSV } from "../../functions";
import PageHeader from "../../components/page-header";
import StatsCards from "../../components/stats-cards";
import ShowHideModal from "../../components/show-hide-modal";
import ButtonsState from "../../components/buttons-state";
const Grades = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchHeaderKet, setSearchHeaderKey] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [hiddenId, setHiddenId] = useState(false);
  const [gradeName, setGradeName] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [editId, setEditId] = useState(false);
  const [opened, setOpened] = useState(null);
  const headers = [
    {
      label: "ID",
      dataIndex: "grade_id",
      search: true,
      sort: true
    },
    perms?.includes("*2_5") || perms?.startsWith("2_5")
      ? {
        label: "Subscriptions",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div>
              <ButtonsState state="view" onClick={() => {
                navigate("students", {
                  state: {
                    grade_id: row?.grade_id,
                    grade_name: row?.grade_name
                  }
                })
              }} />
            </div>
          );
        }
      }
      : {},
    // {
    //   label: "Posts",
    //   type: "children",
    //   children: ({ headers, row }) => {
    //     return (
    //       <div>
    //         <button
    //           className="btn btn-primary"
    //           onClick={() =>
    //             navigate("/posts", {
    //               state: { grade_id: row?.grade_id },
    //             })
    //           }
    //         >
    //           Posts
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    perms?.includes("*2_6") || perms?.startsWith("2_6")
      ? {
        label: "Material",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div>
              <ButtonsState state="view" onClick={() => {
                navigate("/chains", {
                  state: {
                    grade_id: row?.grade_id,
                    grade_name: row?.grade_name,
                    university_id: location?.state?.university_id
                  }
                })
              }} />

            </div>
          );
        }
      }
      : {},
    {
      label: "grade_name",
      dataIndex: "grade_name",
      search: true,
      sort: true
    },
    // {
    //   label: "college_name",
    //   dataIndex: "college_name",
    // },
    {
      label: "Current status",
      type: "children",
      children: ({ row }) => {
        if (row.hidden !== "yes") {
          return <span className="text-success textCurrent">Active</span>;
        } else {
          return <span className="text-danger textCurrent">Inactive</span>;
        }
      }
    },
    perms?.includes("*2_3") || perms?.startsWith("2_3")
      ? {
        label: "Actions",
        type: "children",
        children: ({ headers, row, index, lastIndex }) => {
          return (
            <div className="menu_Open_close">
              <div
                className="open_close"
                style={{ cursor: "pointer", color: "black" }}
                onClick={() => {
                  const currentId = row?.course_subscription_id || row?.chapter_subscription_id || row?.grade_id;
                  setOpened(opened == currentId ? null : currentId);
                }}
              >
                <img
                  src="https://res.cloudinary.com/duovxefh6/image/upload/v1701489400/menu_hrpzcb.png"
                  alt=""
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
              {(row?.course_subscription_id || row?.chapter_subscription_id || row?.grade_id) == opened ? (
                <div
                  className={
                    index == lastIndex - 1 ||
                      index == lastIndex - 2 ||
                      index == lastIndex - 3
                      ? "actions-views row-actions-view"
                      : "actions-views column-actions-view"
                  }
                >
                  {/* <button
                  className="btn btn-danger"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    setDeleteId(row);
                  }}
                >
                  Delete
                </button> */}
                  {perms?.includes("*2_3") || perms?.startsWith("2_3") ? (
                    <ButtonsState
                      state={"edit"}
                      onClick={() => setEditId(row)}
                    />
                  ) : null}
                  {/* setEditId */}
                </div>
              ) : null}
            </div>
          );
        }
      }
      : {},
    perms?.includes("*2_4") || perms?.startsWith("2_4")
      ? {
        label: "Change status",
        type: "children",
        children: ({ row }) => {
          if (row.hidden !== "no") {
            return (
              <ButtonsState
                state={"activate"}
                onClick={() => {
                  setHiddenId({
                    grade_id: row?.grade_id,
                    grade_name: row?.grade_name,
                    status: "no"
                  });
                }}
              />
            );
          } else {
            return (
              <ButtonsState
                state={"deactivate"}
                onClick={() => {
                  setHiddenId({
                    grade_id: row?.grade_id,
                    grade_name: row?.grade_name,
                    status: "yes"
                  });
                }}
              />
            );
          }
        }
      }
      : {}

    // setHiddenId
  ];

  useEffect(() => {
    fetchData();
  }, []);

  window.addEventListener("click", (e) => {
    if (
      opened &&
      !e.target?.classList?.contains("actions-views") &&
      !e.target?.parentNode?.classList?.contains("open_close")
    ) {
      setOpened(null);
    }
  });

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + "grades/select_grades.php", {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
        university_id: location?.state?.university_id
      });
      setData(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const addGrade = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    try {
      const response = await axios.post(BASE_URL + "grades/insert_grade.php", {
        grade_name: gradeName?.value,
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
        university_id: location?.state?.university_id
      });

      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setShowAdd(false);
        form.reset();
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const handleDeleteGrade = () => {
    const data_send = {
      grade_id: deleteId?.grade_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token
    };
    axios
      .post(BASE_URL + "grades/delete_grade.php", JSON.stringify(data_send))
      .then((res) => {
        if (res.data.status == "success") {
          toast.success(res.data.message);
          setDeleteId(false);
          fetchData();
        } else if (res.data.status == "error") {
          toast.error(res.data.message);
        } else {
          toast.error("Something Went Error");
        }
      });
  };
  const handleEditGrade = (e) => {
    e.preventDefault();
    const data_send = {
      grade_id: editId?.grade_id,
      grade_name: gradeName,
      university_id: location?.state?.university_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token
    };
    try {
      axios
        .post(BASE_URL + "grades/update_grade.php", data_send)
        .then((res) => {
          if (res.data.status == "success") {
            toast.success(res.data.message);
            setEditId(false);
            fetchData();
          } else if (res.data.status == "error") {
            toast.error(res.data.message);
          } else {
            toast.error("Something Went Error");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };
  const hideUniv = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "grades/show_hide_grade.php",
        {
          grade_id: hiddenId?.grade_id,
          hidden: hiddenId?.status,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          university_id: location?.state?.university_id
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setHiddenId(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <div className="childs">
            <PageHeader
              title="Grades"
              description="Manage grade information and settings"
              exportButton={
                perms?.includes("*17_2") || perms?.startsWith("17_2")
                  ? true
                  : false
              }
              deleteButton={
                perms?.includes("*2_2") || perms?.startsWith("2_2")
                  ? true
                  : false
              }
              addButton="Add Grade"
              data={data}
              setShowAdd={setShowAdd}
              addition={
                perms?.includes("*2_2") || perms?.startsWith("2_2")
                  ? addition
                  : null
              }
            />
            <StatsCards data={data} title="Grades" icon={addition} />

            <TableLayout
              searchHeaderKet={searchHeaderKet}
              headers={headers}
              data={data}
            />
          </div>
        }
      />
      <Modal
        headerTitle={"Add Grade"}
        open={showAdd}
        toggle={setShowAdd}
        children={
          <form
            action="#"
            onSubmit={!loading ? addGrade : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="grade_name">Grade Name</label>
              <Input
                type={"text"}
                id={"grade_name"}
                name={"grade_name"}
                onChange={setGradeName}
              />
            </div>

            <button className="btn btn-success">
              {!loading ? "Save" : <Loader />}
            </button>
          </form>
        }
      />
      <Modal
        open={hiddenId}
        toggle={setHiddenId}
        headerTitle={"Show / Hide Grade"}
        children={
          <ShowHideModal
            hiddenId={hiddenId}
            hidden={hiddenId?.status === "no" ? true : false}
            setHiddenId={setHiddenId}
            loading={loading}
            hideUniv={hideUniv}
            title="Grade"
          />
        }
      />
      <Modal
        open={deleteId}
        toggle={setDeleteId}
        headerTitle={"Delete Grade"}
        children={
          <>
            <h5>
              {"Are You Sure To Delete Unversity - " +
                deleteId?.grade_name +
                " ?"}
            </h5>
            <div className="flex-box">
              <button
                className="btn btn-danger"
                onClick={() => {
                  handleDeleteGrade();
                }}
              >
                Yes
              </button>

              <button
                className="btn btn-primary"
                width={"fit-content"}
                onClick={() => {
                  setDeleteId(false);
                }}
              >
                No
              </button>
            </div>
          </>
        }
      />

      <Modal
        headerTitle={"Edit Grade"}
        open={editId}
        toggle={setEditId}
        children={
          <form
            action="#"
            onSubmit={!loading ? handleEditGrade : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="grade_name">Grade Name</label>
              <Input
                type={"text"}
                id={"grade_name"}
                name={"grade_name"}
                defaultValue={editId?.grade_name}
                onChange={(e) => setGradeName(e.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              />
            </div>

            <button className="btn btn-success">
              {!loading ? "Save" : <Loader />}
            </button>
          </form>
        }
      />
    </div>
  );
};

export default Grades;
